// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__lItag","bigColWidth":"Table_bigColWidth__hkdex","biggerColWidth":"Table_biggerColWidth__wmxj2","row":"Table_row__17AP4","col":"Table_col__2OQP2"};